'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var lodash = require('lodash');

let _components = {};
const getComponents = () => _components;
const resetComponents = () => {
    _components = {};
};
const registerComponents = (componentRoot, namespace = null) => {
    const componentNames = Object.keys(componentRoot).filter(key => key !== '__esModule');
    let componentsRegistry = {};
    const componentsToRegister = {};
    componentNames.forEach((componentPath) => {
        componentsToRegister[componentPath] = componentRoot[componentPath];
    });
    if (namespace !== null) {
        lodash.set(componentsRegistry, namespace, componentsToRegister);
    }
    else {
        componentsRegistry = componentsToRegister;
    }
    _components = lodash.merge(_components, componentsRegistry);
};
var registry = _components;

exports["default"] = registry;
exports.getComponents = getComponents;
exports.registerComponents = registerComponents;
exports.resetComponents = resetComponents;
//# sourceMappingURL=index.js.map
